import React from "react";
import PropTypes from "prop-types";

const QuoteBlockSection = ({section}) => {
  let { content, colour, bgColour, topMargin, bottomMargin, heading } = section;
  let blockCount = content.items.length;

  return (
    <div className={`wrapper block-wrapper bg-${bgColour} ${topMargin} ${bottomMargin}`}>
      <div className="wrapper--inner flex flex-w-w flex-jc-sb">
        {heading && <h2 className={`color-${colour} ff-s h2 block-heading`} dangerouslySetInnerHTML={{__html: heading}}></h2>}
        <div className="col-1 flex flex-w-w flex-jc-sb align-start-l">
          {content.items.map((item) => {
            let content = item.content;
            return (
              <div key={item.id} className={`col-1 col-lg-${blockCount}-1 bg-${colour} quote padding-default`}>
                <div className="cta-block-content">
                  <blockquote className="col-1 ff-ss">
                    {content.quote}
                  </blockquote>
                  <footer className="col-1 ff-ss">
                    {content.name}
                  </footer>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}


QuoteBlockSection.propTypes = {
  section: PropTypes.object.isRequired
}

export default QuoteBlockSection;
